import { ApiModel } from '@/api/api-model';
import { AcuerdoComercial } from './AcuerdoComercial';
import { Administracion } from './Administracion';
import { TipoConsorcio } from '@/views/acuerdo-comercial/acuerdo-comercial.consts';
import { capitalize } from 'lodash';

export const API_TYPE_MODULOS_DEFAULT = 'consorcio';

export class Consorcio extends ApiModel {

  api_type = API_TYPE_MODULOS_DEFAULT;

  nombre: string;
  tipo: TipoConsorcio;
  cantidad_ufs_facturables: number;
  tipos_ufs?: {[name:string]:number};
  facturando: boolean;
  fecha_creacion: Date;
  solo_comunicacion: boolean;
  periodo_inicio_administracion?: Date;
  archivado: boolean; // Flag para detectar si esta archivado o no

  jira?:{
    informador?: string,
    descuento?: string,
    estado_cliente?: string
  }

  propuesta_consorcio?: AcuerdoComercial; // Relación con el AC, si es que tiene, flag que nos sirve para saber si tiene o no y en caso que tenga saber el estado del AC (Ej. de uso: a la hora de la creación y listar consorcios, aquellos con AC (tendrán esta relación y entrando a la misma el estado) no se listarán como habilitados.)

  administracion: Administracion;
  propuesta_default?: AcuerdoComercial; // Acuerdo comercial por default de la administracion

  /**
   * Retorna el nombre del consorcio formateado
   * [id] Nombre del consorcio
   */
  get nombre_con_id_formateado() {
    return '[' + this.id + '] ' + this.nombre.toUpperCase();
  }

  /**
   * Retorna el tooltip del nombre del consorcio con su tipo asociado. 
   * Nombre del consorcio - Tipo del consorcio
   */
  get nombre_consorcio_con_tipo_tooltip_formateado(){
    return this.nombre + ' - ' + capitalize(this.tipo);
  }

  /**
   * Calculo de cuantos unidades funcionales son primarias
   * Primarias: departamentos y locales o lotes
   */
  get cantUfsPrimarias(){
    if (this.tipo === TipoConsorcio.EDIFICIO){
      return this.cantidadDepartamentos + this.cantidadLocales;
    }
    return this.cantidadLotes;
  }

  /**
   * Calculo de cuantos unidades funcionales son secundarias
   */
  get cantUfsSecundarias(){
    let cocheras = this.cantidadCocheras;
    let bauleras = this.tipos_ufs.baulera ?? 0;
    return cocheras + bauleras;
  }

  /**
   * Calculo de cuantos departamentos tiene el consorcio
   */
  get cantidadDepartamentos(){
    return this.tipos_ufs && this.tipos_ufs.depto ? this.tipos_ufs.depto : 0;
  }

  /**
   * Calculo de cuantos locales tiene el consorcio
   */
  get cantidadLocales(){
    return this.tipos_ufs && this.tipos_ufs.local ? this.tipos_ufs.local : 0;
  }

  /**
   * Calculo de cuantas cocheras tiene el consorcio
   */
  get cantidadCocheras(){
    return this.tipos_ufs &&  this.tipos_ufs.cochera ? this.tipos_ufs.cochera : 0;
  }

  /**
   * Calculo de cuantos lotes tiene el consorcio
   */
  get cantidadLotes(){
    return this.tipos_ufs && this.tipos_ufs.lote ? this.tipos_ufs.lote : 0;
  }

  /**
   * Atributo calculado para obtener el link al ticket de jira.
   * @returns href al link o null si no existe
   */
  get ticketJira(){
    return this.hasApiLink('ticket_jira') ? this.getApiLink('ticket_jira').href : null;
  }
}